// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"77145e3d","239":"d25a5d48","453":"87ca5223","732":"fb0e86e8"}[chunkId] + ".chunk.js";
};